import React from "react";
import { createBrowserRouter, Navigate } from "react-router-dom";
import { AU26, SU26, CATEGORIES } from "./catalog.ts";
import Layout from "../components/layout/index.tsx";
import Main, { mainLoader } from "../views/Main.tsx";
import CollectionView, { collectionLoader } from "../views/collections/CollectionView.tsx";
import CheckoutView, { checkoutLoader } from "../views/order/CheckoutView.tsx";
import OrderView, { orderLoader } from "../views/order/OrderView.tsx";
import PrivacyPolicyView from "../views/privacyPolicy/PrivacyPolicyView.tsx";
import ProductView, { productLoader } from "../views/products/ProductView.tsx";
import ResearchView, { researchesLoader } from "../views/research/ResearchView.tsx";
import PublicOfferView from "../views/privacyPolicy/PublicOfferView.tsx";
import SexView from "../views/collections/SexView.tsx";
import ResearchDescription, { researchLoader } from "../views/research/ResearchDescription.tsx";
import PaymentSuccess from "../views/payment/PaymentSuccess.tsx";
import NotFound from "../components/errors/NotFound.tsx";
import AllSexView from "../views/collections/AllSexView.tsx";
import SearchView from "../views/collections/SearchView.tsx";

export const customRouter = createBrowserRouter([
  {
    path: "/",
    element: <Layout />,
    errorElement: <NotFound />,
    children: [
      { path: "/", element: <Main />, children: [
        
      ] },
      {
        path: "/products/:productId",
        element: <ProductView />,
        loader: productLoader,
      },
      {
        path: "/men",
        element: <SexView sex={0} collectionId={AU26.id} />,
      },
      {
        path: "/women",
        element: <SexView sex={1} collectionId={AU26.id} />,
      },
      {
        path: `/${AU26.slug}`,
        element: <AllSexView collectionId={AU26.id} title={AU26.label} />,
      },
      {
        path: `/${SU26.slug}`,
        element: <AllSexView collectionId={SU26.id} title={SU26.label} />,
      },
      // категорії за типом одягу: бекенд фільтрує за назвою моделі
      ...CATEGORIES.map((c) => ({
        path: `/c/${c.slug}`,
        element: <AllSexView search={c.search} title={c.label} />,
      })),
      // старі адреси лишаються робочими, щоб не побити зовнішні посилання
      { path: "/search", element: <SearchView /> },
      { path: "/autumn-2024", element: <Navigate to={`/${AU26.slug}`} replace /> },
      { path: "/spring-2025", element: <Navigate to={`/${SU26.slug}`} replace /> },
      {
        path: "/collections/:collectionId",
        element: <CollectionView collectionId={AU26.id}/>,
        loader: collectionLoader,
      },
      {
        path: "/order",
        element: <OrderView />,
        loader: orderLoader,
      },
      {
        path: "/checkout",
        element: <CheckoutView />,
        loader: checkoutLoader,
      },
      {
        path: "/privacy-policy",
        element: <PrivacyPolicyView />,
      },
      {
        path: "/public-offer",
        element: <PublicOfferView />,
      },
      {
        path: "/research",
        element: <ResearchView />,
        loader: researchesLoader,
      },
      {
        path: "/research/:researchId",
        element: <ResearchDescription />,
        loader: researchLoader,
      },
      {
        path: "/page/success",
        element: <PaymentSuccess />
      }
    ],
  },
]);
